import CloseIcon from '../../assets/icons/close.svg'
import NumberFormat from 'react-number-format'
import './ModalSaleDetails.css'
import { closeModal } from '../../utils/functions/modal'

const baseUrl = process.env.REACT_APP_URL_BACKEND_BASE

const ModalSaleDetails = ({ sale, setSale }) => {
  const closeModalSaleDetails = () => {
    setSale(undefined)
    closeModal('.container-modal-sale-details')
  }

  return (
    <div className="container-modal-sale-details">
      <div className="modal-sale-details">
        <div className="header-modal">
          <h3>Venta <b>#{sale?.id}</b></h3>
          <button onClick={() => closeModalSaleDetails()}>
            <img src={CloseIcon} alt="" />
          </button>
        </div>
        <div className="body-modal">
          <div className="container-sale-details">
            <div className="sale-section">
              <h4>Comprador</h4>
              <div className="buyer-grid">
                <div>
                  <span className="label">Nombre</span>
                  <p>{sale?.comprador?.nombre}</p>
                </div>
                <div>
                  <span className="label">Email</span>
                  <p>{sale?.comprador?.email}</p>
                </div>
                <div>
                  <span className="label">Teléfono</span>
                  <p>{sale?.comprador?.telefono || <span className="no-value">Sin datos</span>}</p>
                </div>
                <div>
                  <span className="label">Provincia</span>
                  <p>{sale?.comprador?.provincia || <span className="no-value">Sin datos</span>}</p>
                </div>
                <div className="span-2">
                  <span className="label">Dirección</span>
                  <p>{sale?.comprador?.direccion || <span className="no-value">Sin datos</span>}</p>
                </div>
              </div>
            </div>

            <div className="sale-section">
              <h4>Productos</h4>
              <div className="sale-items">
                {sale?.compra?.map((item, key) => (
                  <div className="sale-item" key={key}>
                    <img
                      className="sale-item-image"
                      src={item.imagen && baseUrl ? `${baseUrl}/${item.imagen}` : ''}
                      alt={item.nombre}
                      onError={e => { e.target.style.visibility = 'hidden' }}
                    />
                    <div className="sale-item-info">
                      <p className="sale-item-name">{item.nombre}</p>
                      <span className="sale-item-qty">
                        {item.cantidad} x{' '}
                        <NumberFormat
                          value={item.precio}
                          displayType="text"
                          prefix="$"
                          thousandSeparator="."
                          decimalSeparator=","
                        />
                      </span>
                    </div>
                    <NumberFormat
                      className="sale-item-subtotal"
                      value={item.precio * item.cantidad}
                      displayType="text"
                      prefix="$"
                      thousandSeparator="."
                      decimalSeparator=","
                    />
                  </div>
                ))}
              </div>
            </div>

            <div className="sale-total">
              <span>Total</span>
              <NumberFormat
                value={sale?.total}
                displayType="text"
                prefix="$"
                thousandSeparator="."
                decimalSeparator=","
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalSaleDetails
